import styled from 'styled-components';

export default styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  width: 100%;
  height: 100%;
  overflow: hidden;

  .data-link-cont {
    .button-cont {
      display: flex;
      justify-content: flex-end;

      .ant-btn {
        margin-top: -34px;
      }
    }
  }
  
  textarea {
    font-size: 16px !important;
  }

  .ant-form-item {
    margin-bottom: var(--size);
  }

  .group {
    .daf-title {
      margin-top: var(--size-md);
    }

    .max-char-cont {
      // margin-bottom: 48px;
    }

    &:first-child {
      .daf-title {
        margin-top: 0px;
      }
    }
  }

  .delete-btn {
    svg {
      margin-top: 4px;
      color: var(--red-60);
    }
  }

  .sca-btn {
    width: 104px;

    span {
      margin-right: auto;
      margin-left: auto;
    }

    &.submit {
      background: var(--blue-100);
      border-color: var(--blue-100);

      &:hover {
        background: var(--blue-90);
        border-color: var(--blue-90); 
      }

      &[disabled] {
        background: #f5f5f5;
        border-color: #d9d9d9;
      }
    }
  }

  .title-semibold-1 {
    font-family: 'SF UI Display' !important;
    font-weight: 600 !important;
    font-size: 30px !important;
    line-height: 38px !important;
    color: #001529;
  }

  .title-semibold-2 {
    font-family: 'SF UI Display' !important;
    font-weight: 600 !important;
    font-size: var(--size-lg) !important;
    line-height: 32px !important;
    color: #001529;
  }

  .title-semibold-3 {
    font-family: 'SF UI Display' !important;
    font-weight: 600 !important;
    font-size: var(--font-size-lg) !important;
    line-height: 26px !important;
    color: #001529;
  }

  .title-semibold-4 {
    font-family: 'SF UI Display' !important;
    font-weight: 600 !important;
    font-size: var(--font-size-lg) !important;
    line-height: var(--size-lg) !important;
    color: #001529;
  }

  .title-semibold-5 {
    font-family: 'SF UI Display' !important;
    font-weight: 600 !important;
    font-size: 14px !important;
    line-height: 22px !important;
    color: #001529;
  }

  .title-semibold-6 {
    font-family: 'SF UI Display' !important;
    font-weight: 600 !important;
    font-size: 12px !important;
    line-height: 20px !important;
    color: #001529;
  }
  .ant-page-header {
    .ant-space {
      width: 100%;
      .ant-space-item {
        width: 100%;
      }
    }
    
    .ant-page-header-heading-left {
      overflow: initial;
    }

    .ant-page-header-back-button {
      margin-bottom: 2px;

      span[role="img"] {
        color: var(--color-primary-70);
      }
    }

    .ant-page-header-heading-extra {
      width: -webkit-fill-available;

      .actions {
        width: 100%;
        display: flex;
        flex-direction: row;
        justify-content: flex-end;
        padding-right: 12px;

        .ant-btn {
          margin-right: 8px;
          border-radius: 8px;

          span[role="img"] {
            font-size: 14px;
            margin-top: 2px;
          }
        }
      }
    }

    .tag {
      display: flex;
      flex-direction: row;
      justify-content: flex-start;
      align-items: center;

      p {
        margin: 0 8px 0 0;
      }
    }
  }

  .view-loader {
    position: absolute;
    width: 100%;
    height: 100%;
    background: rgba(255, 255, 255, 0.1);
    color: var(--color-primary-70);
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    font-size: 38px;
  }

  .ant-menu {
    min-width: 200px;
    height: 100%;

    .ant-menu-item {
      // &.ant-menu-item-selected {
      //   border-right: 2px solid;
      // }

      padding-left: var(--size) !important;
    }

    .ant-menu-submenu {
      .ant-menu-submenu-title {
        padding-left: var(--size) !important;
      }

      .ant-menu.ant-menu-sub {
        .ant-menu-item {
          padding-left: 32px !important;
        }
      }
    }
  }

  .entity-name {
    line-height: 1;
    margin: auto;
    display: flex;
    font-size: var(--font-size-lg);

    .anticon {
      vertical-align: 0;
      margin-right: 3px;
      margin-top: 0px;
    }
  }

  .view-content {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    position: relative;
    width: 100%;
    flex: 1;
    overflow: auto;

    .content {
      width: 100%;
      display: flex;
      flex-direction: column;
      overflow-y: auto;
      padding: 20px 20px 0 20px;

      &.risk-template.no-padding {
        padding: 0;
        overflow-y: auto;
        flex-direction: row;
      }

      .title {
        margin-bottom: 20px;
        font-size: var(--size-lg);
      }

      .wrapper {
        padding: 0;
        display: flex;
        flex-direction: row;
        flex-wrap: wrap;

        .group {
          width: 100%;
          background: #fbfbfb;
          border: 1px solid #f2f2f2;
          padding: var(--size);
          display: flex;
          flex-direction: row;
          flex-wrap: wrap;
          margin-bottom: 20px;

          .title {
            width: 100%;
            display: flex;
            align-items: center;
            margin-bottom: var(--size);

            h1 {
              font-size: 18px;
              color: #001529;
              margin-bottom: 0;
            }
          }

          .input {
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            width: calc(100% / 4);
            border-bottom: 1px solid #e4e8ed;
            margin-bottom: var(--size);

            .label,
            .value {
              font-size: 14px;
              color: #828282;
              line-height: 22px;
              margin: 0;
            }

            .value {
              color: #001529;
              font-weight: 400;
              margin-bottom: var(--size);
              margin-top: 8px;
            }
          }

          .input.last {
            margin: 0;
            border: none;

            .value {
              margin: 0;
              margin-top: 8px;
            }
          }
        }

        .group.repeatable {
          .repeatable-row {
            width: 100%;
            display: flex;
            background: white;
          }

          .input {
            margin-right: 0 !important;
            margin: 0;
            border-bottom: none;

            .label {
              padding-bottom: 12px;
              border-bottom: 1px solid #e4e8ed;
              min-height: 35px;
            }

            .value {
              padding: 12px 0;
              background: white;
              border-bottom: 1px solid #e4e8ed;
              min-height: 48px;
              margin-bottom: 0;
              margin-top: 0;
            }
          }

          .input.action {
            .value {
              text-align: center;
            }
          }

          .no-data {
            margin: 0;
            padding: 12px;
            background: white;
            width: 100%;
            text-align: center;
          }
        }

        .group.repeatable {
          .input {
            .label {
              height: 100%;
            }
          }

          .repetable-row-extra {
            width: 100%;
            display: flex;
            flex-wrap: wrap;
            padding: var(--size) 0;
            background: white;
            justify-content: center;
            border-bottom: 1px solid #e4e8ed !important;
            overflow: hidden;
            transition: all 300ms ease;

            .input {
              display: flex !important;
              flex-direction: column;
              justify-content: space-between;
              border-bottom: 1px solid #e4e8ed;
              margin-bottom: var(--size);
            }

            .label,
            .value {
              font-size: 14px;
              color: #828282;
              line-height: 22px;
              margin: 0;
              border-bottom: none;
              padding-right: var(--size);
            }

            .value {
              color: #001529;
              font-weight: 400;
              margin-bottom: var(--size);
              background: none;
              border-bottom: none;
              padding: 0;
              min-height: unset;
            }

            .input.last {
              margin: 0;
              border: none;

              .value {
                margin: 0;
              }
            }
          }
        }
      }
    }

    .anticon {
      vertical-align: 0;
    }

    .form-edit {
      width: 100%;
      display: flex;
      justify-content: center;
      padding-top: var(--size-lg);
      overflow: auto;
      flex-direction: column;
      padding: var(--size-lg) var(--size-lg) 0 var(--size-lg);

      .main-form {
        min-width: 400px;
        width: 100%;
        max-width: 600px;
        min-height: 100%;
        margin: auto;

        .ant-input-number-group-wrapper {
          width: 100%;
        }

        @media screen and (max-width: 1200px) {
          min-width: 600px;
        }

        @media screen and (max-width: 768px) {
          min-width: 100%;
        }

        &.management-form {
          max-width: unset;
        }

        .with-comment {
          .ant-form-item-label label {
            width: 100%;

            &>span {
              display: flex;
              justify-content: space-between;
              width: 100%;

              &>span {
                &>button {
                  line-height: 1;
                  height: inherit;
                  font-size: 14px;
                  padding: 0;
                }
              }
            }
          }

          &.i-radioGroup>.ant-form-item-label>label>span {
            font-style: normal;
            font-weight: bold;
            font-size: 18px;
            line-height: 22px;
            display: flex;
            align-items: center;
            color: #001529;
          }
        }

        .i-radioGroup, .i-checkboxGroup {
          background: #FFFFFF;
          border: 0.5px solid #D7DAEA;
          box-sizing: border-box;
          border-radius: 2px;
          padding: var(--size-lg);
          margin-top: var(--size-lg);

          .ant-radio-group.ant-radio-group-outline, .ant-checkbox-group {
            width: 100%;

            label {
              display: flex;
              min-height: 76px;
              background: white;
              border: 1px solid #d7daea;
              box-sizing: border-box;
              border-radius: 2px;
              margin: var(--size-lg) 0;
              padding: 13px var(--size-lg);

              &.ant-radio-wrapper-checked {
                border-color: var(--color-primary-70);
              }

              .ant-radio, .ant-checkbox {
                margin: auto;
                width: 16px;
              }

              &>span:last-child {
                width: calc(100% - 32px);
                display: flex;
                flex-direction: column;
                margin: auto;

                .radio-title {
                  font-style: normal;
                  font-weight: 600;
                  font-size: var(--font-size-lg);
                  line-height: var(--size-lg);
                  display: flex;
                  align-items: center;
                  color: #001529;
                  white-space: normal !important;
                }

                .radio-description {
                  font-style: normal;
                  font-weight: normal;
                  font-size: 14px;
                  line-height: 22px;
                  display: flex;
                  align-items: center;
                  white-space: normal !important;
                }
              }
            }
          }
        }
        .i-transfer {
          .ant-transfer {
            width: 100%;
            display: flex;
            flex-direction: column;
            .ant-transfer-list {
              height: 300px;
              .ant-transfer-list-body{
                overflow-y: auto;
                .ant-transfer-list-body-customize-wrapper{
                  padding: 0;
                }
              }
              .ant-transfer-list-header{
                .ant-transfer-list-header-selected{
                  display: flex;
                  flex-direction: row-reverse;
                  width: 100%;
                  justify-content: space-between;
                  .ant-transfer-list-header-title {
                    position: inherit;
                    font-size: var(--font-size-lg);
                    color: #001529;
                    font-weight: 700;
                  }
                }
              }
            }
            .ant-transfer-operation {
              display: flex;
              justify-content: space-around;
              width: 100px;
              margin: 10px;
              button{
                transform: rotate(90deg);
                .anticon{
                  position: absolute;
                  top: 4px;
                  left: 0;
                  right: 0;
                }
              }
            }
          }
        }

        .comment-textarea {
          label {
            width: 100%;

            .ant-btn {
              height: unset;
              color: var(--red-60);
              display: flex;
              flex-direction: column;
              justify-content: center;
            }

            &:after {
              display: none;
            }
          }
          .ant-form-item-control-input {
            max-width: 100%;
          }
        }

        .ant-row.ant-form-item.comment-textarea {
          margin-top: -12px;

          textarea {
            border-top: none;
          }
        }

        .ant-picker {
          width: 100%;

          .ant-picker-suffix {
            margin-top: -6px;
          }

          .ant-picker-clear {
            margin-top: -3px;
          }
        }

        .ant-input-number {
          width: 100%;
        }

        .title-semibold-4 {
          font-size: 18px;
          font-weight: 700;
          font-style: normal;
          line-height: 22px;
          color: #001529;
        }

        .ant-col.ant-form-item-label label {
          font-size: 14px;
          font-style: normal;
          font-weight: normal;
          line-height: 22px;
          color: var(--base-gray-90);
          flex: 1;
        }

        .i-transfer>.ant-form-item-label>label {
          padding: 14px 0;
        }

        .ant-form-item-control-input-content {
          display: flex;
          gap: var(--margin-md);
        }

        .repeatable {
          border: 0.5px solid #D7DAEA;
          box-sizing: border-box;
          border-radius: 2px;
          padding: 20px;

          .ant-form-item-control-input-content {
            display: flex;
            gap: var(--margin-md);
          }
          
          .inputs {
            .i-switch {
              .ant-col {
                width: unset;
                flex: 0;
              }

              .ant-form-item-label {
                flex: 1;
              }

              .ant-form-item-control {
                justify-content: flex-end;
                margin: auto;
                padding-left: 10px;
              }
            }
          }
        }

        .i-modal {
          &>.ant-col.ant-form-item-label label {
            margin-top: 1.5rem !important;
            font-size: 18px;
            font-weight: 700;
            font-style: normal;
            line-height: 22px;
            color: #001529;

            span>span {
              font-size: 18px;
              font-weight: 700;
              font-style: normal;
              line-height: 22px;
              color: #001529;
            }
          }
        }

        .ajax-modal-view {
          padding: 18px;
          width: 100%;
          border: 1px dashed #D7DAEA;
          box-sizing: border-box;
          border-radius: 2px;
          padding-top: 5px;

          .link-row {
            height: auto;
            display: flex;
            line-height: var(--size);
            min-height: 32px;
            padding: 5px 0;

            .ant-image {
              height: 50px;
              width: 100px !important;

              .ant-image-img {
                object-fit: cover;
                height: 50px;
              }
            }

            &.even {
              background: #F9FAFC;
            }

            span {
              width: 50%;
              padding: 0 12px;
              margin: auto;
            }
          }
        }

        .repeatable-item {
          border: 1px dashed #D7DAEA;
          box-sizing: border-box;
          border-radius: 2px;
          padding: 15px;

          .ajax-modal-view {
            padding-top: 0px;
          }
          .total-inputs-1 {
            .ajax-modal-view {
              .remove-button-row {
                display: none !important;
              }
            }
          }
        }

        .ajax-modal-edit {
          background: #FFFFFF;
          border: 0.5px solid #D7DAEA;
          box-sizing: border-box;
          border-radius: 2px;
          padding: 20px;
          width: 100%;
          margin-bottom: var(--size-lg);

          .form-modal {
            width: 100%;
          }

          .form-botom {
            display: flex;
            justify-content: center;

            button {
              border-radius: 8px;
            }
          }
        }

        .i-switch {
          display: flex;
          flex-direction: column;
        }
      }
    }
  }

  .risk-template {
    display: flex;

    .risk-categories-list {
      justify-content: center;
      display: flex;
      flex-direction: column;
      height: 100%;

      .risk-categories {
        width: 100%;
        min-height: 100px;
        margin-bottom: var(--size);
        margin-top: var(--size);
        white-space: break-spaces;
      }

    }
  }

  .risk-form-edit {
    background: #E5E5E5;

    .i-undefined {
      display: none;
    }

    .risk-header {
      padding: var(--size-lg);
      border-bottom: 1px solid #D1D1D1;
      margin-bottom: 20px;

      h1 {
        font-size: 20px;
        margin-bottom: 0px;
      }
    }

    .ant-form {
      .i-radioGroup {
        border: 0px !important;
        margin-top: 0px !important;
        padding: 0px var(--size-lg) !important;
      }

      .polygons {
        display: flex;
        gap: 4px;
      }

      .risk-edit-form-body {
        background: white;
        box-shadow: 0px 5px 11px rgba(0, 0, 0, 0.18);
        border-radius: 4px;
      }

      .ant-form-item {
        padding: 0px var(--size-lg);
      }
      
      .title-semibold-4 {
        padding: 0px var(--size-lg);
      }

      .risk-color-blue {
        color: var(--color-primary-70);
        font-size: 20px;
        font-weight: 500;
        margin-bottom: 0px;
        line-height: 30px;
        padding: 0px var(--size-lg);
      }

      .repeatable-desc {
        padding: 0px var(--size-lg);
        margin-top: var(--size);
        font-weight: 600;
        margin-bottom: 0px;
        font-size: var(--font-size-lg);
      }

      .ant-space {
        margin-bottom: 0px !important;
      }
    }

    .repeatable {
      border: 0px !important;
      padding: 0px 0px 0px 0px !important;
    }

    .risk-radio-group {
      display: flex;
      gap: 20px;

      .ant-radio-wrapper {
        flex-direction: row-reverse;

        .left {
          display: flex;
          gap: var(--size);
          border-right: 1px solid #C8C8C8;
          padding-right: var(--size);
          margin-right: 8px;

          .cont {
            display: flex;
            flex-direction: column;
            justify-content: center;
          }

          .description {
            .radio-description {
              font-size: 14px !important;
              font-weight: 500;
            }

            .radio-title {
              font-size: 14px !important;
              font-weight: 500 !important;
            }
          }
        }
      }

      .info {
        margin-top: 22px;
        height: fit-content;
        padding: 12px;
        border: 1px solid #C8C8C8;
        width: 190px;
        border-radius: 4px;

        p {
          font-size: 14px;
          font-weight: 500;
          margin-bottom: 12px;

          &.description {
            margin-top: 10px;
            margin-bottom: 0px;
          }
        }

        .icon-cont {
          svg {
            width: 21px;
            height: 18px;
          }
        }

        h4 {
          font-size: var(--font-size-lg);
          font-weight: 600;
          margin-bottom: 10px;

          &.no-value {
            color: var(--color-primary-70);
            margin-bottom: 12px;
          }
        }
      }
    }

    .risk-edit-form-body-planning {
      .is-risk-radio {
       .ant-radio-wrapper {
          margin: 0px !important;
          padding: 0px !important;
          border: 0px !important;
          min-height: 32px !important;
       } 

       .radio-title {
          font-weight: 500 !important;
          font-size: var(--font-size-lg);
       }

        span {
          margin: 0px !important;
        }
      }

      .risk-item-cont {
        padding: var(--size-lg);
        background: white;
        box-shadow: 0px 5px 11px rgba(0, 0, 0, 0.18);
        margin-top: var(--size-lg);

        .risk-item-cont-header {
          padding: 0px 0px var(--size-lg) 0px;

          .title-semibold-4 {
            font-size: 20px !important;
            margin-left: 0px;
            font-weight: 500;
            padding-left: 0px;
          }
        }
      }

      .repeatable-item  {
        padding: 0px 0px 20px 0px !important;
        border-radius: 4px;
        margin-bottom: var(--size-lg) !important;

        .title-semibold-4 {
          color: black !important;
          font-size: 20px !important;
          font-weight: 500 !important;
          margin-bottom: 0px;
          margin-top: 2px;
        }

        .d-flex  {
          padding: 20px 0px;
        }
      }
    }
  } 

  .total100 {
    display: flex;
    flex-direction: column;
    width: 100%;
    .ant-space-item:nth-of-type(3n) {
      flex-grow: initial;
    }
    .ant-space-item:not(:last-of-type) {
      width: calc(50% - 4px)
    }
    .ant-space {
      margin-top: 8px;
    }
  }
  .risk-plan {
    padding: var(--size-lg);
    border-radius: 4px;
    background: white;
    color: #001529;
    box-shadow: 0px 5px 11px rgba(0, 0, 0, 0.18);

    .subScore {
      display: flex;
      min-width: 100px;

      .cont {
        display: flex;
        flex-direction: column;
        justify-content: center;
        margin-right: var(--size);
      }

      padding-top: 3.5px;
      p {
        margin: 0;
        margin-bottom: 4px;
      }

      .levels {
        display: flex;
        justify-content: space-between;
        height: 15px;

        div {
          width: 15px;
          margin-right: 3px;
          height: 100%;
          background: #f3f3f3;

          &:last-of-type {
            margin-right: 0;
          }
        }
      }
    }
  }

  .risk-name{
    color: #001529;
    font-style: italic;
  }

  .i-imageUpload{
    margin-top: 22px;
  }

  .ant-form-item-control-input {
    max-width: 514px;
  }

  .ant-upload-wrapper {
    width: 100%;
  }

  .ant-form-item-explain-error {
    margin-bottom: var(--size-lg);
  }

  .input-cont {
    position: relative;

    .code {
      position: absolute;
      right: 0px;

      span {
        font-size: var(--size-sm);
        color: var(--base-gray-60);
      }
    }
  }
`;
